// Footer component

const Footer = () => {
   return (
      <footer>
         <p>Created with 💙 by <a href="https://www.joeysea.com/">Joey Sea</a> at <a href="https://junocollege.com"> Juno College of Technology</a></p>
      </footer>
   )
}

export default Footer;